<ng-container *ngIf="loaded">
    <app-products-detail-section-a [product]="product" [products]="products" [filters]="filters" class="fill-height"></app-products-detail-section-a>
    <app-products-detail-section-b [product]="product"></app-products-detail-section-b>
    <app-products-detail-section-c *ngIf="loaded" [product]="product"></app-products-detail-section-c>
</ng-container>